import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AreaLayerService = {
    getById: async (id) => axios.get(API_URL + `/areaLayer/getArea/${id}`).then(({data}) => data).catch((err) => { throw err }),
    sendKmz: async (formData) => axios.post(API_URL + "/areaLayer/sendKmz", formData).then(({data}) => data).catch((err) => { throw err }),
    save: async (formData) => axios.post(API_URL + "/areaLayer", formData).then(({data}) => data).catch((err) => { throw err }),
    remove: async (id) => axios.delete(API_URL + `/areaLayer/${id}`).then(({data}) => data).catch((err) => {throw err}),
    list: async () =>  axios.get(API_URL + `/areaLayer-list`).then(({data}) => data).catch((err) => { throw err }),
    allSectors: async () => axios.get(`${API_URL}/areaLayer/get/allSectors`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
}

export default AreaLayerService;